import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Dashboards/Reporting/widgetInReport/components/widgetErrorFallback/WidgetErrorFallback.module.scss';

export const WidgetErrorFallback = () => {
    return (
        <div className={classes.widgetFallback}>
            <MuiIcon icon={'warning'} fontSize={'2.8rem'} />
            <div className={classes.errorTitle}>We're having trouble displaying this widget</div>
            <div className={classes.errorSubTitle}>
                Please try refreshing the page or contact support if the problem persists.
            </div>
        </div>
    );
};
